import React from 'react';
import { AlertCircle } from 'lucide-react';
interface DataTableProps {
  data: any[];
  columns: string[];
  emptyMessage?: string;
  rowClassName?: (row: any) => string;
}
export function DataTable({
  data,
  columns,
  emptyMessage = 'No records found.',
  rowClassName
}: DataTableProps) {
  if (!data || data.length === 0) {
    return <div className="flex flex-col items-center justify-center py-16 px-4 text-center bg-white rounded-lg border border-slate-200 shadow-sm" data-id="element-1">
        <div className="bg-slate-50 p-3 rounded-full mb-3" data-id="element-2">
          <AlertCircle className="w-6 h-6 text-slate-400" data-id="element-3" />
        </div>
        <h3 className="text-sm font-medium text-slate-900" data-id="element-4">
          No Data Available
        </h3>
        <p className="text-sm text-slate-500 mt-1" data-id="element-5">{emptyMessage}</p>
      </div>;
  }
  // Get headers from the first item if columns aren't manually mapped,
  // but usually we want to control the column order/display.
  // For this dynamic CSV tool, we might need to be flexible.
  const displayHeaders = columns;
  return <div className="overflow-hidden rounded-lg border border-slate-200 shadow-sm bg-white" data-id="element-6">
      <div className="overflow-x-auto" data-id="element-7">
        <table className="min-w-full divide-y divide-slate-200" data-id="element-8">
          <thead className="bg-slate-50" data-id="element-9">
            <tr data-id="element-10">
              {displayHeaders.map((header, index) => <th key={index} scope="col" className="px-6 py-3 text-left text-xs font-semibold text-slate-500 uppercase tracking-wider whitespace-nowrap" data-id="element-11">
                  {header}
                </th>)}
            </tr>
          </thead>
          <tbody className="bg-white divide-y divide-slate-200" data-id="element-12">
            {data.map((row, rowIndex) => <tr key={rowIndex} className={`hover:bg-slate-50 transition-colors ${rowClassName ? rowClassName(row) : ''}`} data-id="element-13">
                {displayHeaders.map((header, colIndex) => {
              // Handle nested properties or direct access
              const cellValue = row[header] !== undefined ? row[header] : '';
              return <td key={`${rowIndex}-${colIndex}`} className="px-6 py-4 text-sm text-slate-700 whitespace-nowrap" data-id="element-14">
                      {cellValue}
                    </td>;
            })}
              </tr>)}
          </tbody>
        </table>
      </div>
      <div className="bg-slate-50 px-6 py-3 border-t border-slate-200 text-xs text-slate-500 flex justify-between items-center" data-id="element-15">
        <span data-id="element-16">Showing {data.length} records</span>
      </div>
    </div>;
}